import { Modal } from '../components/Modal';

type Props = { onClose: () => void; onContinue: () => void };

export function VipWarningModal({ onClose, onContinue }: Props) {
    return (
        <Modal title="Только для VIP" onClose={onClose}>
            <div className="popup-hero">👑</div>
            <p className="popup-text text-center">
                Для создания заданий нужен статус <b>VIP</b>.
            </p>
            <p className="popup-text text-center text-muted">
                Без VIP можно тестировать форму, но публикация заблокирована.
            </p>
            <button type="button" className="action-btn btn-gold" onClick={onContinue}>
                Открыть форму
            </button>
            <button type="button" className="action-btn btn-mute" onClick={onClose}>
                Отмена
            </button>
        </Modal>
    );
}
